import type { SubMenuFragment } from '@/graphql/api'

export const hasImageInEachItem = (subMenuItem: SubMenuFragment): boolean =>
    subMenuItem.sections.every((section) =>
        section.items.every((item) => item.media)
    )
